import React, { useEffect, useRef, useState } from 'react';
import './MobilePlansSwipe.css';

const MobilePlansSwipe = ({ plans = [], step = 2 }) => {
  const containerRef = useRef(null);
  const [index, setIndex] = useState(0);
  const startX = useRef(0);
  const deltaX = useRef(0);
  const animRef = useRef(null);

  // Auto-swipe: Basic -> Pro -> Elite
  useEffect(() => {
    let step = 0;
    const sequence = [0, 1, 2];
    const run = () => {
      if (step >= sequence.length) return;
      setIndex(sequence[step]);
      step += 1;
      animRef.current = setTimeout(run, 700);
    };
    animRef.current = setTimeout(run, 400);
    return () => clearTimeout(animRef.current);
  }, []);

  // Touch handlers
  const onTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const onTouchMove = (e) => {
    deltaX.current = e.touches[0].clientX - startX.current;
  };

  const onTouchEnd = () => {
    if (Math.abs(deltaX.current) < 30) return; // small move ignored
    if (deltaX.current < 0) {
      // swipe left -> next
      setIndex((i) => Math.min(i + 1, plans.length - 1));
    } else {
      // swipe right -> prev
      setIndex((i) => Math.max(i - 1, 0));
    }
    deltaX.current = 0;
  };

  // Elite is the selected plan (step === 2). Users can swipe but cannot 'select' lesser options.
  const highlightedIndex = 2;
  const isSelectable = (i) => i === highlightedIndex;

  return (
    <div
      className="mobile-plans-swipe"
      ref={containerRef}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div
        className="mobile-plans-track"
        style={{ transform: `translateX(calc(${ -index * 100 }%))` }}
      >
        {plans.map((plan, i) => (
          <div
            key={plan.name}
            className={`plan-box ${i === highlightedIndex && step === 2 ? 'highlighted' : ''}`}
          >
            <h3 className="plan-name">{plan.name}</h3>
            <p className="price">{plan.price}</p>
            <ul className="ululul">
              {plan.features.map((f, idx) => (
                <span key={idx}>
                  <span className="checkmark">✔</span> {f}
                  <span className="featureSpace"> <br /> </span>
                </span>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobilePlansSwipe;
